import { useEffect, useState } from "react";

const DESKTOP_BREAKPOINT = "(min-width: 768px)";

export function useIsDesktop(): boolean {
	const [isDesktop, setIsDesktop] = useState(true);

	useEffect(() => {
		if (typeof window.matchMedia !== "function") {
			return;
		}

		const mql = window.matchMedia(DESKTOP_BREAKPOINT);
		setIsDesktop(mql.matches);
		const handler = (e: MediaQueryListEvent): void => setIsDesktop(e.matches);
		mql.addEventListener("change", handler);
		return () => mql.removeEventListener("change", handler);
	}, []);

	return isDesktop;
}
